/**
 * Block Reveal functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class BlockReveal {
  /**
   * Constructs a new Block Reveal instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.rev1Element = document.querySelector('#rev-1')
    this.rev2Element = document.querySelector('#rev-2')
    this.reputationElement = document.querySelector('#reputation-reveal')
    this.qualityElement = document.querySelector('#quality-reveal')
    this.ourElement = document.querySelector('#our-reveal')
    this.clientsElement = document.querySelector('#clients-reveal')
    this.clientsCopyElement = document.querySelector('#clients-copy-reveal')
    this.contactElement = document.querySelector('#contact-reveal')
    this.aboutElement = document.querySelector('#about-reveal')
    this.lexonElement = document.querySelector('#lexon-reveal')
    this.aboutLexonFirstCopyElement = document.querySelector('#about-lexon-first-copy-reveal')
    this.aboutLexonSecondCopyElement = document.querySelector('#about-lexon-second-copy-reveal')
    this.aboutLexonThirdCopyElement = document.querySelector('#about-lexon-third-copy-reveal')
    this.aboutLexonFourthCopyElement = document.querySelector('#about-lexon-fourth-copy-reveal')

    // Main Title Reveals
    // if (this.rev1Element) {
    //   this.rev1 = new RevealFx(this.rev1Element, {
    //     revealSettings : {
    //       bgcolor: '#f57613',
    //       onCover: function(contentEl, revealerEl) {
    //         contentEl.style.opacity = 1
    //       }
    //     }
    //   })
    //   this.rev1.reveal()
    // }

    ////////////////////////////

    this.about = new RevealFx(this.aboutElement, {
      revealSettings : {
        bgcolor: '#f57613',
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.lexon = new RevealFx(this.lexonElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 250,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.aboutLexonFirstCopy = new RevealFx(this.aboutLexonFirstCopyElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 500,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.aboutLexonSecondCopy = new RevealFx(this.aboutLexonSecondCopyElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 750,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.aboutLexonThirdCopy = new RevealFx(this.aboutLexonThirdCopyElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 1000,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.aboutLexonFourthCopy = new RevealFx(this.aboutLexonFourthCopyElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 1250,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    // this.rev2 = new RevealFx(this.rev2Element, {
    //   revealSettings : {
    //     bgcolor: '#f57613',
    //     delay: 250,
    //     onCover: function(contentEl, revealerEl) {
    //       contentEl.style.opacity = 1
    //     }
    //   }
    // })
    // this.rev2.reveal()

    // Hero Copy Reveals
    this.reputation = new RevealFx(this.reputationElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 250,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })
    this.quality = new RevealFx(this.qualityElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 400,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    // Our Clients Reveals
    this.our = new RevealFx(this.ourElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 250,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })
    this.clients = new RevealFx(this.clientsElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 400,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })
    this.clientsCopy = new RevealFx(this.clientsCopyElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 400,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

    this.contact = new RevealFx(this.contactElement, {
      revealSettings : {
        bgcolor: '#f57613',
        delay: 400,
        onCover: function(contentEl, revealerEl) {
          contentEl.style.opacity = 1
        }
      }
    })

  }

  reputationReveal() {
    this.reputation.reveal()
  }

  qualityReveal() {
    this.quality.reveal()
  }

  ourReveal() {
    this.our.reveal()
  }

  clientsReveal() {
    this.clients.reveal()
  }

  clientsCopyReveal() {
    this.clientsCopy.reveal()
  }

  contactReveal() {
    this.contact.reveal()
  }

  aboutReveal() {
    this.about.reveal()
  }

  lexonReveal() {
    this.lexon.reveal()
  }

  aboutLexonFirstCopyReveal() {
    this.aboutLexonFirstCopy.reveal()
  }

  aboutLexonSecondCopyReveal() {
    this.aboutLexonSecondCopy.reveal()
  }

  aboutLexonThirdCopyReveal() {
    this.aboutLexonThirdCopy.reveal()
  }

  aboutLexonFourthCopyReveal() {
    this.aboutLexonFourthCopy.reveal()
  }

}



// WEBPACK FOOTER //
// ./components/block-reveal/index.js